var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.28829 23.6667H15.5998C16.7371 23.6667 17.8279 23.2149 18.6321 22.4107C19.4363 21.6064 19.8881 20.5157 19.8881 19.3784V12.6029C19.8885 11.4657 19.4372 10.3749 18.6334 9.57045L11.3201 2.25586C10.9218 1.85766 10.4491 1.54181 9.92876 1.32633C9.40845 1.11084 8.8508 0.999959 8.28764 1H5.28829C4.15096 1 3.06022 1.4518 2.25601 2.25601C1.4518 3.06022 1 4.15096 1 5.28829V19.3784C1 20.5157 1.4518 21.6064 2.25601 22.4107C3.06022 23.2149 4.15096 23.6667 5.28829 23.6667Z",
    fill: "#E6EBED",
    stroke: "#E6EBED",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0618 1.4375V8.37228C10.0618 9.02218 10.3199 9.64546 10.7795 10.105C11.239 10.5646 11.8623 10.8227 12.5122 10.8227H19.4494",
    fill: "#D2D2D2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0618 1.4375V8.37228C10.0618 9.02218 10.3199 9.64546 10.7795 10.105C11.239 10.5646 11.8623 10.8227 12.5122 10.8227H19.4494",
    stroke: "#E6EBED",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.62421 17.8476V16.6223V17.8476ZM4.62421 16.6223V14.1719H5.84943C6.17438 14.1719 6.48602 14.301 6.7158 14.5307C6.94557 14.7605 7.07466 15.0722 7.07466 15.3971C7.07466 15.7221 6.94557 16.0337 6.7158 16.2635C6.48602 16.4932 6.17438 16.6223 5.84943 16.6223H4.62421ZM9.52511 17.8476V14.1719H10.1377C10.6251 14.1719 11.0926 14.3655 11.4373 14.7102C11.7819 15.0548 11.9756 15.5223 11.9756 16.0097C11.9756 16.4971 11.7819 16.9646 11.4373 17.3093C11.0926 17.6539 10.6251 17.8476 10.1377 17.8476H9.52511ZM14.426 17.8476V16.316V17.8476ZM16.2638 14.1719H14.426V16.316M14.426 16.316H16.2638H14.426Z",
    fill: "#E6EBED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.62421 17.8476V16.6223M4.62421 16.6223V14.1719H5.84943C6.17438 14.1719 6.48602 14.301 6.7158 14.5307C6.94557 14.7605 7.07466 15.0722 7.07466 15.3971C7.07466 15.7221 6.94557 16.0337 6.7158 16.2635C6.48602 16.4932 6.17438 16.6223 5.84943 16.6223H4.62421ZM14.426 17.8476V16.316M14.426 16.316V14.1719H16.2638M14.426 16.316H16.2638M9.52511 17.8476V14.1719H10.1377C10.6251 14.1719 11.0926 14.3655 11.4373 14.7102C11.7819 15.0548 11.9756 15.5223 11.9756 16.0097C11.9756 16.4971 11.7819 16.9646 11.4373 17.3093C11.0926 17.6539 10.6251 17.8476 10.1377 17.8476H9.52511Z",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdfIcon.eea083f6d283584534984b29e5dff06c.svg";
export { ForwardRef as ReactComponent };